export const LANG_EN_DICTIONARY = {
  LANG_EN: 'English',
  LANG_ES: 'Spanish',
  LANG_PT: 'Portuguese',
  ALERTA_SUCESSO: 'Success',
  ALERTA_ERRO: 'Error',
  ALERTA_ATENCAO: 'Warning',
  ALERTA_INFORMACAO: 'Information',
  ALERTA_QUESTAO: 'Confirm?',
  BOTAO_SIM: 'Yes',
  BOTAO_NAO: 'No',
  LABEL_EMPRESA: 'Companies',
  LABEL_PERIODO: 'Period',
  LABEL_PERIODO_HOJE: 'Today',
  LABEL_PERIODO_SETE: 'Last 7 Days',
  LABEL_PERIODO_TRINTA: 'Last 30 Days',
  LABEL_PERIODO_ATUAL: 'Current Month',
  LABEL_PERIODO_ANTERIOR: 'Previous Month',
  LABEL_FILTROS: 'Filters',
  MENU_STATUS: 'Status',
  TOAST_SUCESSO: 'Success',
  TOAST_ERRO: 'Error',
  TOAST_ATENCAO: 'Warning',
  TOAST_INFORMACAO: 'Information',
} as const;
